import axios from "axios";
import { urls } from "../config/urls";

// Create axios instance with default headers
export const request = axios.create({
  baseURL: urls.apiBaseUrl,
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json",
  },
});

async function getToken() {
  try {
    const response = await axios.post('https://anax.api.srashtasoft.in/api/token', {
     
    });
    
    const token = response.data.token; 
    localStorage.setItem('user', JSON.stringify({ token }));
    
    console.log("Token retrieved and stored:", token);
    return token;
  } catch (error) {
    console.error("Error fetching token:", error);
    throw error;
  }
}


request.interceptors.request.use(
  async function (config) {
    const user = JSON.parse(localStorage.getItem('user')); 

    
    if (!user?.token) {
      console.log("No token found, fetching new token");
      const token = await getToken(); 
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = `Bearer ${user.token}`;
    }

    return config;
  },
  function (error) {
    console.error("Error in request interceptor:", error);
    return Promise.reject(error);
  }
);


request.interceptors.response.use(
  (response) => {
  
    return Promise.resolve(response);
  },
  async (error) => {
    console.error("Response error:", error);

    // Handle 401 Unauthorized error (token expired or invalid)
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized, token might be expired. Redirecting to login.");
      localStorage.clear();
      window.location.href = "/"; // Redirect to the home or login page
    }

    // Handle other errors (network, etc.)
    return Promise.reject(error); // Reject the error so it can be handled in the calling code
  }
);

